/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_NewInputs */



/**
* | output |
* | --- |
* | "New conversation" |
*
* @param {Chat_NewInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_new = /** @type {((inputs?: Chat_NewInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_NewInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Nieuw gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouvelle conversation")
	return /** @type {LocalizedString} */ ("New conversation")
});